
import { supabase } from "@/integrations/supabase/client";
import { BaseApiClient } from "./baseApiClient";
import { logger } from "@/lib/logger";

export const userApiClient = {
  getCurrentUser: async () => {
    return BaseApiClient.request<string | null>(
      'user:current',
      async () => {
        try {
          const { data } = await supabase.auth.getSession();
          if (!data.session) {
            return null;
          }
          return data.session.user.id;
        } catch (error) {
          logger.error({
            message: "Error fetching current user session",
            error: error instanceof Error ? error : new Error(String(error)),
            context: { action: "getCurrentUser" }
          });
          return null;
        }
      }
    );
  },
  
  getProfile: async (userId: string) => {
    return BaseApiClient.request<any | null>(
      `user:profile:${userId}`,
      async () => {
        try {
          const { data, error } = await supabase
            .from('profiles')
            .select('*')
            .eq('id', userId)
            .maybeSingle();
          
          if (error) {
            throw new Error(`Failed to fetch profile: ${error.message}`);
          }
          
          return data;
        } catch (error) {
          logger.error({
            message: "Error fetching user profile",
            error: error instanceof Error ? error : new Error(String(error)),
            context: { userId }
          });
          return null;
        }
      }
    );
  },
  
  clearCache: () => {
    BaseApiClient.clearCache('user:');
  }
};
